let UsedPlayers = {
    USED_PLAYERS_SET_FILTER_POSITION: 'USED_PLAYERS_SET_FILTER_POSITION',
    USED_PLAYERS_SET_FILTER_TIER: 'USED_PLAYERS_SET_FILTER_TIER',
    USED_PLAYERS_SET_FILTER_SHOWDOWN: 'USED_PLAYERS_SET_FILTER_SHOWDOWN',
    USED_PLAYERS_SET_FILTER_SINGLE_GAME: 'USED_PLAYERS_SET_FILTER_SINGLE_GAME',
};

export default UsedPlayers;
